import {call, put} from "redux-saga/effects";
import {
    deletePackageApi,
    excelExportPackagesApi,
    getConsultationPackagesListApi,
    getHistoriquePackageApi,
} from "../../../../common/apis/packageApi";
import * as actions from "../state/consultationPackagesActions";

export function* getConsultationPackagesListSaga({ payload }) {
  try {
    const response = yield call(getConsultationPackagesListApi, payload);
    yield put(
      actions.getConsultationPackagesListSuccessAction(response.data.body)
    );
  } catch (error) {
    yield put(actions.getConsultationPackagesListFailAction(error));
    console.error(error);
  }
}

export function* getHistoriquePackageSaga({ payload }) {
  try {
    const response = yield call(getHistoriquePackageApi, payload);
    yield put(actions.getHistoriquePackageSuccessAction(response.data.body));
  } catch (error) {
    yield put(actions.getHistoriquePackageFailAction(error));
    console.error(error);
  }
}

export function* deletePackageSaga({ payload }) {
  try {
    const response = yield call(deletePackageApi, payload);
    yield put(actions.deletePackageSuccessAction(response.data.body));
  } catch (error) {
    yield put(actions.deletePackageFailAction(error));
    console.error(error);
  }
}

export function* excelExportPackageSaga({ payload }) {
  try {
    const response = yield call(excelExportPackagesApi, payload);
    yield put(actions.printSuccess(response.data));
  } catch (error) {
    yield put(actions.printFail(error));
  }
}